export const _ADD               = "3rDl5Z2ZSj7D96ZWH2aDHQ==";
export const _EDIT              = "wZ9PEufXS9KA7xdEX1Lq2Q==";
export const _VIEW              = "8DB40YMkkomr+oCO7j8zyw==";
export const _DELETE            = "JlsPtvzqIlmkq7FzkHs36Q==";
export const _RECOVER           = "p9Y1CcCARiDXMUImHFE6oQ==";
export const _LIST              = "IzQf4qdRNVqt8Y14hlIOTg==";
export const _TRASH             = "tVx+P+7r7o7tkd4T2bAkrg==";